import store from '@/store';
import Taro from '@tarojs/taro';
import { isWeixin } from '&/utils/common'
import { handleLogin } from '@/utils/common'
import { createProject } from '@/api/landingPage'


export const handleCreateProject = (isApp, appToken) => {
    return createProject({ isApp, token: appToken }).then(res => {

        if (!res || !res.data) return

        const { data: { status, projectPath: { web } } } = res

        if (+status === 1) { //新用户
            Taro.navigateTo({
                url: `pages/landingPage/useSuccess?status=success&copyUrl=${web}`
            });
        } else if (+status === 2) { // 已领取
            if (isApp) {
                externalDispatchFun('HDC', 'gotoProjectList', '')
                return
            }
            Taro.navigateTo({
                url: 'pages/home/index'
            })
        } else { // 已过期
            Taro.navigateTo({
                url: 'pages/landingPage/useSuccess?status=expired'
            })
        }
    }).catch(err => {
        Promise.reject('err', err)
    })
}

export const freeUseNow = (isApp, appToken) => {
    if (isApp) {
        handleCreateProject(isApp, appToken)
        return
    }
    if (!isWeixin()) {
        Taro.navigateTo({
            url: 'pages/landingPage/freeUseNotWx'
        })
        return
    }
    if (!store.appStore.token) {
        handleLogin(null, window.location.origin + '/pages/login/index?from=freeUse', true)
    } else {
        handleCreateProject(isApp)
    }
}

export const targetToQQUrl = 'http://wpa.qq.com/msgrd?v=3&uin=2881472761&site=qq&menu=yes'

export const handleGoQQ = (isApp) => {
    // alert(1)
    if (isApp) {
        externalDispatchFun('HDC', 'openQQ', '')
        return
    }
    window.location.href = targetToQQUrl
    if (Taro.getSystemInfoSync().system === 'iOS') {
        setTimeout(() => {
            window.location.replace(window.location.href)
        }, 1000)
    }
}

